<template>
  <div :id="id" :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import echarts from "echarts";

export default {
  name: "line-charts-order",
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "235px"
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    };
  },
  computed: {
    isCollapsed() {
      return this.$store.state.app.sidebar.clapse;
    }
  },
  watch: {
    isCollapsed() {
      this.resizeCharts();
    }
  },
  mounted() {
    this.initLineCharts();
    this.resizeCharts();
    window.addEventListener("resize", () => {
      this.resizeCharts();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    window.removeEventListener("resize", () => {
      this.resizeCharts();
    });
    this.chart.dispose(); // 销毁
    this.chart = null;
  },
  methods: {
    /**
     * 重置图表
     */
    resizeCharts() {
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize();
        }
      }, 350);
    },
    /**
     * 初始化图表
     */
    initLineCharts() {
		console.log('chartData==',this.chartData)
      this.chart = echarts.init(document.getElementById(this.id));
      let chartData = Object.assign({}, this.chartData);
      let legendData = []; // 图例
      let xData = []; // x轴
      let seriesData = []; // x轴
      console.log(this.chartData.time.data)
      xData = this.chartData.time.data;
      delete chartData.time;

      for (let key in chartData) {
        legendData.push(chartData[key].name);

        seriesData.push({
          name: chartData[key].name,
          type: "line",
          symbol:'circle',
          smooth: true,
          symbolSize: 5,
          showSymbol: false,  
          lineStyle: {
            normal: {
              width: 1
            }
          },
          data: Object.values(chartData[key].data)
        });
      }

      this.chart.setOption({
        color:['#4381E5','#FF7B49','#01A787'], 
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: "#57617B"
            }
          }
        },
        legend: {
          // top: 20,
          data: legendData,
          right: "4%",
          textStyle: {
            fontSize: 12,
            color: "#888888"
          }
        },
        grid: {
          top: 40,
          left: "2%",
          right: "4%",
          bottom: "2%",
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLine: {
              lineStyle: {
                color: "#EEEEEE"
              }
            },
            axisLabel: {
              textStyle: {
                color: "#939393"
              }
            },
            data: xData
          }
        ],
        yAxis: [
          {
            type: "value",
            minInterval: 2,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: "#EEEEEE"
              }
            },
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 14
              }
            },
            splitLine: {
              lineStyle: {
                color: "#EEEEEE"
              }
            },
            axisLabel: {
              textStyle: {
                color: "#939393"
              }
            }
          }
        ],
        series: seriesData
      });
    }
  }
};
</script>

<style lang=""></style>
